(function () {
  const items = document.querySelectorAll('.drads-reveal');
  if (items.length && 'IntersectionObserver' in window) {
    const observer = new IntersectionObserver(
      (entries, currentObserver) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          currentObserver.unobserve(entry.target);
        });
      },
      { rootMargin: '0px 0px -12% 0px', threshold: 0.08 }
    );

    items.forEach((item) => observer.observe(item));
  } else if (items.length) {
    items.forEach((item) => item.classList.add('is-visible'));
  }

  document.querySelectorAll('.drads-projects').forEach((projectsSection) => {
    const projectsToggle = projectsSection.querySelector('.drads-projects__mobile-toggle');
    const projectsStack = projectsSection.querySelector('.drads-projects__stack');
    const projectsStatus = projectsSection.querySelector('[data-projects-status]');

    if (!projectsToggle || !projectsStack || projectsToggle.dataset.projectsInitialized === 'true') return;

    projectsToggle.dataset.projectsInitialized = 'true';

    const isMobile = () => window.matchMedia('(max-width: 749px)').matches;
    const scrollToContext = (target) => {
      if (!target || !isMobile()) return;
      window.requestAnimationFrame(() => {
        const headerOffset = 76;
        const targetTop = target.getBoundingClientRect().top + window.scrollY - headerOffset;
        window.scrollTo({ top: Math.max(targetTop, 0), behavior: 'smooth' });
      });
    };

    projectsToggle.addEventListener('click', () => {
      const isExpanded = projectsSection.classList.toggle('is-expanded');
      projectsToggle.setAttribute('aria-expanded', String(isExpanded));
      projectsToggle.textContent = isExpanded
        ? projectsToggle.dataset.labelHide
        : projectsToggle.dataset.labelShow;

      if (projectsStatus) {
        projectsStatus.textContent = isExpanded
          ? 'Les deux autres cas d’usage sont maintenant affichés.'
          : 'Les autres cas d’usage sont masqués.';
      }

      /* Put the first revealed card at the top of the viewport so the visitor
         keeps the projects section in context without adding another heading. */
      scrollToContext(isExpanded ? projectsStack : projectsToggle);
    });
  });
})();
